import React, { useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';

// ──────────────────────────────────────────────────────────────────────────
// "Registro del motivo específico de No apto" (observación posterior al feedback
// del Director, 22/09/2026): cuando GDH marca a un candidato como No apto — en
// cualquiera de las etapas donde toma esa decisión, no solo Revisión Inicial —
// el sistema debe pedir el motivo específico del descarte antes de confirmar.
//
// Catálogo hardcodeado en el front "por mientras" (a pedido explícito, todavía
// no se define si vive en dbo.DataType u otra tabla configurable). El motivo
// elegido se guarda en TP_Postulante.MotivoNoApto y el texto libre de "Otro
// motivo" (máx. 40 caracteres) en TP_Postulante.MotivoNoAptoOtro; etapa, usuario
// GDH y fecha/hora de la decisión ya quedan en TP_CambiosEstado — ver
// ProcesoRepositoryWrite.java (actualizarMotivoNoApto).
// ──────────────────────────────────────────────────────────────────────────

export const MOTIVO_OTRO = 'Otro motivo';

export const MOTIVOS_NO_APTO = [
    'Tiempo de actividad',
    'Grado académico requerido',
    'Evaluación de desempeño',
    'Amonestaciones o sanciones',
    MOTIVO_OTRO,
];

const MotivoNoAptoModal = ({ toggleModal, onConfirm }) => {
    const [motivo, setMotivo] = useState('');
    const [motivoOtro, setMotivoOtro] = useState('');
    const [isSending, setIsSending] = useState(false);

    const handleGuardar = async () => {
        if (!motivo) {
            toast.error('Selecciona el motivo específico del descarte.');
            return;
        }
        setIsSending(true);
        try {
            // motivo: siempre la opción del catálogo elegida (incluye "Otro motivo." cuando
            // corresponde). motivoOtro: texto libre opcional, null si no aplica o va vacío.
            await onConfirm(motivo, (motivo === MOTIVO_OTRO && motivoOtro.trim()) || null);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Motivo de No apto" width="480px">
            <div className="modal-body">
                <p className="text-muted" style={{ fontSize: 13 }}>
                    Selecciona el motivo específico del descarte del candidato.
                </p>

                <div className="form-group">
                    <label className="modal-label mb-0 required">Motivo de No apto</label>
                    <select className="form-control" value={motivo} disabled={isSending}
                        onChange={(e) => {
                            setMotivo(e.target.value);
                            if (e.target.value !== MOTIVO_OTRO) setMotivoOtro('');
                        }}>
                        <option value="">Selecciona un motivo</option>
                        {MOTIVOS_NO_APTO.map((m) => (
                            <option key={m} value={m}>{m}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="modal-label mb-0">Especificar motivo (otro)</label>
                    <textarea className="form-control" rows={2} maxLength={40}
                        disabled={isSending || motivo !== MOTIVO_OTRO}
                        value={motivoOtro} onChange={(e) => setMotivoOtro(e.target.value)}
                        placeholder="Escribe el motivo específico" />
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-outline-secondary mr-2" disabled={isSending}
                        onClick={toggleModal}>
                        Cancelar
                    </button>
                    <button type="button" className="btn generic-button-buscador generic-button-hover-rojo"
                        disabled={isSending} onClick={handleGuardar}>
                        Guardar
                    </button>
                </div>
            </div>
        </GenericModal>
    );
};

export default MotivoNoAptoModal;
